import { useState } from "react";
import { api, apiError } from "../../lib/api";
import { Eyebrow } from "../../components/bits";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

const field = "w-full bg-white border border-[#e0ddd4] rounded-sm px-4 py-3 text-sm focus:border-[#d4af37]";
const labelCls = "text-xs tracking-wide text-[#555] uppercase mb-1.5 block";

export default function Careers() {
  const [f, setF] = useState({ name: "", email: "", phone: "", postcode: "", experience: "", availability: "", areas: "", driving: "No", right_to_work: "Yes", cv_note: "" });
  const [done, setDone] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!f.name || !/.+@.+\..+/.test(f.email)) { toast.error("Please complete name and email"); return; }
    try { await api.post("/public/careers", f); setDone(true); toast.success("Application submitted"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  if (done) return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center">
      <CheckCircle2 className="text-[#d4af37] mx-auto" size={50} />
      <h1 className="font-display text-4xl mt-6">Application received</h1>
      <p className="text-[#555] mt-3">Thank you for your interest in joining Black Diamond Elite Cleaning. Our team will review your application and be in touch.</p>
    </div>
  );

  return (
    <div>
      <section className="bg-[#0a0a0a] relative">
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-3xl mx-auto px-5 sm:px-8 pt-20 pb-14">
          <Eyebrow dark>Careers</Eyebrow>
          <h1 className="font-display text-[#fdfbf7] text-4xl sm:text-5xl tracking-tight">Join our team</h1>
          <p className="text-[#cfcabf] mt-4">We're building a team of carefully managed, professional cleaners across London. Tell us about yourself.</p>
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div><label className={labelCls}>Full name *</label><input data-testid="career-name" className={field} value={f.name} onChange={(e) => set("name", e.target.value)} /></div>
        <div><label className={labelCls}>Email *</label><input data-testid="career-email" className={field} value={f.email} onChange={(e) => set("email", e.target.value)} /></div>
        <div><label className={labelCls}>Phone</label><input className={field} value={f.phone} onChange={(e) => set("phone", e.target.value)} /></div>
        <div><label className={labelCls}>Postcode</label><input className={field} value={f.postcode} onChange={(e) => set("postcode", e.target.value)} /></div>
        <div className="sm:col-span-2"><label className={labelCls}>Cleaning experience</label><textarea rows="2" className={field} value={f.experience} onChange={(e) => set("experience", e.target.value)} /></div>
        <div><label className={labelCls}>Availability</label><input className={field} placeholder="e.g. Weekdays 9-3" value={f.availability} onChange={(e) => set("availability", e.target.value)} /></div>
        <div><label className={labelCls}>Areas you can work</label><input className={field} value={f.areas} onChange={(e) => set("areas", e.target.value)} /></div>
        <div><label className={labelCls}>Driving</label><select className={field} value={f.driving} onChange={(e) => set("driving", e.target.value)}><option>No</option><option>Yes — own car</option><option>Yes — no car</option></select></div>
        <div><label className={labelCls}>Right to work in the UK</label><select className={field} value={f.right_to_work} onChange={(e) => set("right_to_work", e.target.value)}><option>Yes</option><option>No</option><option>Prefer to discuss</option></select></div>
        <div className="sm:col-span-2"><label className={labelCls}>Anything else / CV notes</label><textarea rows="3" className={field} value={f.cv_note} onChange={(e) => set("cv_note", e.target.value)} /></div>
        <div className="sm:col-span-2"><button data-testid="career-submit" onClick={submit} className="btn-gold px-8 py-3 rounded-sm">Submit application</button></div>
      </div>
    </div>
  );
}
